export interface CategoryInfo {
  slug: string;
  name: string;
  description: string;
  heroImage: string;
  stats: {
    weeklyCount: string;
    involvedCount: string;
    truthRate: string;
    onlineHours: string;
  };
}

export interface ArticleCard {
  slug: string;
  title: string;
  subtitle: string;
  tag: string;
  image: string;
  date: string;
  views: number;
}

export const categories: Record<string, CategoryInfo> = {
  'wanghong-fanche': {
    slug: 'wanghong-fanche',
    name: '网红翻车',
    description: '追踪网红翻车第一现场，从塌房到道歉再到复出，全网最全的翻车记录都在这里。',
    heroImage: 'https://readdy.ai/api/search-image?query=Dramatic%20stage%20collapse%20scene%20with%20falling%20spotlights%20and%20dark%20curtains%2C%20warm%20amber%20stage%20lights%20shining%20through%20dust%20particles%2C%20mysterious%20theater%20atmosphere%2C%20cinematic%20noir%20style%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20metaphor&width=1600&height=800&seq=cat-hero-wanghong&orientation=landscape',
    stats: {
      weeklyCount: '128',
      involvedCount: '56',
      truthRate: '94%',
      onlineHours: '24',
    },
  },
  'cabian-fancha': {
    slug: 'cabian-fancha',
    name: '擦边反差',
    description: '表面清纯内里火热？盘点全网最具反差的网红，看看谁才是最会演的那个。',
    heroImage: 'https://readdy.ai/api/search-image?query=Abstract%20split%20face%20artwork%20half%20in%20soft%20warm%20light%20and%20half%20in%20dramatic%20shadow%2C%20duality%20theme%2C%20mysterious%20atmosphere%2C%20rich%20amber%20and%20deep%20burgundy%20contrast%2C%20cinematic%20composition%2C%20editorial%20style%2C%20no%20identifiable%20person%2C%20abstract%20portrait&width=1600&height=800&seq=cat-hero-cabian&orientation=landscape',
    stats: {
      weeklyCount: '93',
      involvedCount: '42',
      truthRate: '91%',
      onlineHours: '24',
    },
  },
  'mingxing-heiliao': {
    slug: 'mingxing-heiliao',
    name: '明星黑料',
    description: '娱乐圈背后的真实面目。从片场到夜店，从绯闻到黑料，我们的狗仔无处不在。',
    heroImage: 'https://readdy.ai/api/search-image?query=Dark%20city%20night%20scene%20with%20paparazzi%20flashes%20reflecting%20off%20a%20black%20limousine%2C%20dramatic%20street%20lights%20creating%20warm%20amber%20pools%2C%20mysterious%20atmosphere%2C%20cinematic%20noir%20style%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20paparazzi%20vibe&width=1600&height=800&seq=cat-hero-mingxing&orientation=landscape',
    stats: {
      weeklyCount: '156',
      involvedCount: '78',
      truthRate: '97%',
      onlineHours: '24',
    },
  },
};

export const categoryArticles: Record<string, ArticleCard[]> = {
  'wanghong-fanche': [
    {
      slug: 'wanghong-sishenghuo',
      title: '某顶流网红被曝私生活混乱',
      subtitle: '多位知情人实名爆料，证据链完整',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dark%20private%20club%20interior%20with%20dim%20warm%20lighting%2C%20velvet%20curtains%2C%20mysterious%20atmosphere%2C%20luxurious%20decor%20details%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20abstract%20metaphor&width=700&height=500&seq=cat-article-w1&orientation=landscape',
      date: '2026-07-06',
      views: 42356,
    },
    {
      slug: 'zhubo-daihuo',
      title: '大主播带货翻车粉丝集体维权',
      subtitle: '涉事金额高达数千万元，平台介入调查',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Shattered%20glass%20display%20window%20on%20dark%20street%20with%20warm%20store%20light%20leaking%20through%2C%20broken%20trust%20metaphor%2C%20cinematic%20lighting%2C%20deep%20burgundy%20and%20amber%20contrast%2C%20editorial%20photography%2C%20dramatic%20atmosphere&width=700&height=500&seq=cat-article-w2&orientation=landscape',
      date: '2026-07-05',
      views: 31200,
    },
    {
      slug: 'wanghong-shujuzuojia',
      title: '某平台头部主播涉嫌数据造假',
      subtitle: '后台真实数据曝光，粉丝量缩水惊人',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20glowing%20red%20and%20amber%20numbers%20on%20monitors%2C%20data%20code%20streaming%2C%20mysterious%20tech%20atmosphere%2C%20cinematic%20lighting%2C%20deep%20shadows%2C%20editorial%20style%2C%20abstract%20digital%20world&width=700&height=500&seq=cat-article-w3&orientation=landscape',
      date: '2026-07-04',
      views: 28900,
    },
    {
      slug: 'wanghong-shuijun',
      title: '网红团队雇佣水军刷好评被抓包',
      subtitle: '聊天截图流出，水军工资明细全曝光',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dark%20room%20with%20multiple%20smartphone%20screens%20glowing%20in%20warm%20amber%20light%2C%20rows%20of%20devices%20on%20table%2C%20mysterious%20social%20media%20farm%20vibe%2C%20cinematic%20composition%2C%20deep%20burgundy%20and%20gold%20tones%2C%20editorial%20photography&width=700&height=500&seq=cat-article-w4&orientation=landscape',
      date: '2026-07-03',
      views: 25400,
    },
    {
      slug: 'wanghong-shuiyin',
      title: '百万粉丝网红盗用他人作品',
      subtitle: '原作者发长文控诉，律师函已发出',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20with%20painting%20canvas%20in%20dramatic%20warm%20lighting%2C%20paint%20brushes%20and%20palettes%20on%20desk%2C%20creative%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20burgundy%20tones%2C%20editorial%20photography%2C%20artistic%20mood&width=700&height=500&seq=cat-article-w5&orientation=landscape',
      date: '2026-07-02',
      views: 21800,
    },
    {
      slug: 'wanghong-xijin',
      title: '某美妆博主被曝偷税漏税',
      subtitle: '税务稽查已介入，名下多家公司被查',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Dark%20office%20desk%20with%20financial%20documents%20spread%20out%2C%20calculator%20and%20pen%20in%20dramatic%20warm%20lighting%2C%20mysterious%20audit%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20corporate%20tension&width=700&height=500&seq=cat-article-w6&orientation=landscape',
      date: '2026-07-01',
      views: 19800,
    },
  ],
  'cabian-fancha': [
    {
      slug: 'wanghong-fancha',
      title: '某清纯系网红私下画风突变',
      subtitle: '粉丝群曝光大量反差照片，人设崩塌',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20split%20image%20two%20mirror%20reflections%20in%20warm%20amber%20light%2C%20duality%20theme%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20visual%2C%20no%20identifiable%20people&width=700&height=500&seq=cat-article-c1&orientation=landscape',
      date: '2026-07-06',
      views: 56700,
    },
    {
      slug: 'wanghong-dabaixian',
      title: '平台头部网红深夜擦边直播',
      subtitle: '直播间被封前数万人围观',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Dark%20empty%20broadcast%20studio%20with%20warm%20ring%20light%20glowing%20against%20dark%20background%2C%20microphone%20stand%20visible%2C%20mysterious%20livestream%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people&width=700&height=500&seq=cat-article-c2&orientation=landscape',
      date: '2026-07-05',
      views: 48900,
    },
    {
      slug: 'wanghong-zhanghao',
      title: '某网红小号被扒内容尺度惊人',
      subtitle: '小号关注列表和互动内容全曝光',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Dark%20close%20up%20of%20smartphone%20screen%20displaying%20social%20media%20feed%20with%20warm%20amber%20light%20reflection%2C%20mysterious%20digital%20content%20atmosphere%2C%20cinematic%20lighting%2C%20deep%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20screen%20texture&width=700&height=500&seq=cat-article-c3&orientation=landscape',
      date: '2026-07-04',
      views: 35600,
    },
    {
      slug: 'wanghong-zaoxing',
      title: '女网红线下被偶遇原形毕露',
      subtitle: '路人实拍生图与精修照判若两人',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dramatic%20mirror%20scene%20with%20foggy%20reflection%20in%20warm%20amber%20light%2C%20distorted%20image%2C%20illusion%20vs%20reality%20theme%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20abstract%20artistic&width=700&height=500&seq=cat-article-c4&orientation=landscape',
      date: '2026-07-03',
      views: 31200,
    },
    {
      slug: 'wanghong-guanxi',
      title: '某网红与多名男性关系复杂',
      subtitle: '聊天记录和转账记录浮出水面',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Dark%20cafe%20table%20scene%20with%20two%20wine%20glasses%20and%20phone%20face%20down%2C%20warm%20candlelight%20ambiance%2C%20mysterious%20date%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20intimate%20tension&width=700&height=500&seq=cat-article-c5&orientation=landscape',
      date: '2026-07-02',
      views: 29800,
    },
    {
      slug: 'wanghong-juben',
      title: '擦边网红团队炒作套路被揭秘',
      subtitle: '内部运营手册外流，全是剧本',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20on%20dark%20wooden%20desk%2C%20warm%20amber%20desk%20lamp%20lighting%2C%20mysterious%20planning%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20strategy%20and%20plot%20theme&width=700&height=500&seq=cat-article-c6&orientation=landscape',
      date: '2026-07-01',
      views: 24500,
    },
  ],
  'mingxing-heiliao': [
    {
      slug: 'mingxing-tuipo',
      title: '某一线男星深夜出入高档会所',
      subtitle: '疑似涉及非法交易，监控画面曝光',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dark%20luxury%20club%20entrance%20with%20warm%20golden%20chandelier%20light%20spilling%20onto%20wet%20pavement%2C%20mysterious%20night%20atmosphere%2C%20cinematic%20noir%20style%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20dramatic%20entrance&width=700&height=500&seq=cat-article-m1&orientation=landscape',
      date: '2026-07-06',
      views: 89300,
    },
    {
      slug: 'mingxing-chugui',
      title: '某女星被曝与导演长期暧昧',
      subtitle: '片场亲密互动视频流出',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Dark%20film%20set%20behind%20the%20scenes%20with%20warm%20stage%20lights%20and%20equipment%20shadows%2C%20mysterious%20production%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20creative%20industry%20vibe&width=700&height=500&seq=cat-article-m2&orientation=landscape',
      date: '2026-07-05',
      views: 75600,
    },
    {
      slug: 'mingxing-feiwen',
      title: '新生代男团成员被曝大量绯闻',
      subtitle: '多名女性站出来实锤',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Dark%20concert%20stage%20with%20dramatic%20spotlights%20and%20silhouette%20of%20empty%20microphones%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20performance%20industry%20theme&width=700&height=500&seq=cat-article-m3&orientation=landscape',
      date: '2026-07-04',
      views: 62100,
    },
    {
      slug: 'mingxing-daibyan',
      title: '某流量小花被曝耍大牌',
      subtitle: '片场工作人员集体吐槽',
      tag: '独家',
      image: 'https://readdy.ai/api/search-image?query=Dark%20movie%20trailer%20interior%20with%20vanity%20mirror%20lights%20and%20makeup%20products%20scattered%2C%20mysterious%20diva%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20luxury%20backstage%20vibe&width=700&height=500&seq=cat-article-m4&orientation=landscape',
      date: '2026-07-03',
      views: 53400,
    },
    {
      slug: 'mingxing-xuepin',
      title: '某男星学术造假风波再起',
      subtitle: '论文查重率98%惊人内幕',
      tag: '追踪',
      image: 'https://readdy.ai/api/search-image?query=Dark%20library%20bookshelves%20with%20warm%20amber%20reading%20lamp%20lighting%20ancient%20books%2C%20mysterious%20academic%20atmosphere%2C%20cinematic%20composition%2C%20rich%20burgundy%20and%20gold%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20scholarship%20and%20scandal%20theme&width=700&height=500&seq=cat-article-m5&orientation=landscape',
      date: '2026-07-02',
      views: 46700,
    },
    {
      slug: 'mingxing-gongs',
      title: '某明星夫妇被传秘密离婚',
      subtitle: '已分居半年，财产分割进行中',
      tag: '内幕',
      image: 'https://readdy.ai/api/search-image?query=Two%20empty%20wine%20glasses%20on%20dark%20marble%20table%20with%20warm%20candlelight%20in%20background%2C%20broken%20relationship%20metaphor%2C%20mysterious%20atmosphere%2C%20cinematic%20composition%2C%20rich%20amber%20and%20deep%20burgundy%20tones%2C%20editorial%20photography%2C%20no%20people%2C%20intimate%20sadness&width=700&height=500&seq=cat-article-m6&orientation=landscape',
      date: '2026-07-01',
      views: 38900,
    },
  ],
};